var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavbarLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.846 3.23H1.154a1.154 1.154 0 110-2.307h15.692a1.154 1.154 0 110 2.308zm-6.461 6.923H1.154a1.154 1.154 0 110-2.307h9.23a1.154 1.154 0 110 2.307zm6.461 6.924H1.154a1.154 1.154 0 110-2.308h15.692a1.154 1.154 0 110 2.308z",
    fill: "#2F5FE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.298 9.729a1.155 1.155 0 00-.08-1.546l-1.901-1.902a1.155 1.155 0 10-1.634 1.634L16.77 9l-1.086 1.085a1.155 1.155 0 101.634 1.634l1.902-1.902c.028-.028.055-.058.08-.088z",
    fill: "#2F5FE3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarLogout);
export default __webpack_public_path__ + "static/media/navbar_logout.6f537e0a661bec59f8782f8cc5ba6a7a.svg";
export { ForwardRef as ReactComponent };